import { ActionGenerator, actionsGenerator } from 'store/utils';

export const GET_DOCTORS = '@DOCTORS/GET';

export const GET_DOCTORS_ACTIONS: ActionGenerator = actionsGenerator(
  GET_DOCTORS,
);
